import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from "vue";
import { EnumApprovalState } from "@/models/enum/Enum";
import ShiftDialog from "./ShiftDialog.vue";

export type Date = {
  weekOfDay: string;
  day: number;
  month: number;
  year: number;
  date: string;
};

type ShiftItem = {
  shiftId: string;
  shiftName: string;
  approvalState: EnumApprovalState;
  date: string;
};
export type Employee = {
  employeeId: number;
  employeeName: string;
  shifts: (ShiftItem | null)[];
};

export type Shift = {
  interval: Date[];
  shift: Employee[];
};

type Props = {
  items: Employee[];
  headers: Date[];
};

export default /*#__PURE__*/_defineComponent({
  __name: 'ShiftTable',
  props: {
    items: null,
    headers: null
  },
  setup(__props: any) {

const props = __props as {
  items: Employee[];
  headers: Date[];
};



const isExist = computed(
  () => props.items.length > 0 && props.headers.length > 0
);

const badgeColor = (state: EnumApprovalState) => {
  switch (state) {
    case EnumApprovalState.UNAPPROVAL:
    case EnumApprovalState.DURING:
      return "primary";
    case EnumApprovalState.RESOLVE:
      return "success";
    case EnumApprovalState.REJECT:
      return "error";
    default:
      return "";
  }
};

const dayColor = (day: string) => {
  if (day === "土") return "blue--text";
  if (day === "日") return "red--text";
  return "";
};

const isOpen = ref(false);
const shiftId = ref<string>("");

const onClick = (item: ShiftItem) => {
  shiftId.value = item.shiftId;
  isOpen.value = true;
};

const activeBtnClass = "indigo--text text--darken-4 text-button text-center";
const disabledBtnClass = "disabled text-button text-center";

return { __sfc: true,props, isExist, badgeColor, dayColor, isOpen, shiftId, onClick, activeBtnClass, disabledBtnClass, ShiftDialog }
}

})